import { FunctionComponent, PropsWithChildren } from 'react';
import { clsx } from 'clsx';

type LinkButtonProps = {
  color?: 'green' | 'pink';
  href: string;
};

const comboColors = {
  green: 'border-techy-green hover:text-techy-green focus:ring-techy-green',
  pink: 'border-friendly-pink hover:text-friendly-pink focus:ring-friendly-pink'
};

const LinkButton: FunctionComponent<PropsWithChildren<LinkButtonProps>> = ({
  children,
  color = 'green',
  href
}) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={clsx(
        'flex items-center px-4 py-2 text-sm font-medium border rounded-md shadow-sm text-egg focus:outline-none focus:ring-2 focus:ring-offset-2',
        comboColors[color]
      )}
    >
      {children}
    </a>
  );
};

export default LinkButton;
